import { Trans } from "../utils/i18n";
import React from "react";

export const queueDetailConfigUnu = {
    "sizes": {
        "forth": 3,
        "third": 4,
        "half": 6,
        "full": 12
    },
    "heading": <Trans i18nKey="orderEntry.basicData">Basic data</Trans>,
    "groups": [
        {
            "heading": <Trans i18nKey="queueDetail.notes.label">Notes</Trans>,
            "fields": [
                {
                    "size": "full",
                    "key": "notes",
                    "name": "notes",
                    "label": <Trans i18nKey="queueDetail.notes.label">Notes</Trans>,
                    "multiline": true,
                },
            ]
        },
        {
            "heading": <Trans i18nKey="queueDetail.appointment.label">Appointment</Trans>,
            "fields": [
                {
                    "name": "appointment_date",
                    "label": <Trans i18nKey="queueDetail.appointment.label">Appointment</Trans>,
                    "size": "full",
                    "type": "datetimepicker",
                },
            ],
        },
        {
            "heading": <Trans i18nKey="queueDetail.oldHardware.heading">Old hardware</Trans>,
            "fields": [
                {
                    "name": "serialnumber",
                    "label": <Trans i18nKey="queues.serialNumber">Serial number</Trans>,
                    "size": "full",
                },
            ]
        },
        {
            "heading": <Trans i18nKey="queueDetail.installationReport.heading">Installation report</Trans>,
            "fields": [
                {
                    "name": "",
                    "size": "full",
                    "component": 'queuedetaildropzone'
                },
            ]
        },
        {
            "heading": <Trans i18nKey="queueDetail.status.heading">Status</Trans>,
            "fields": [
                {
                    "name": "status_id",
                    "size": "full",
                    "type": 'statusselect'
                },
            ]
        },
    ],
}
